var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.125C12.75 3.82663 12.6315 3.54048 12.4205 3.3295C12.2095 3.11853 11.9234 3 11.625 3C11.3266 3 11.0405 3.11853 10.8295 3.3295C10.6185 3.54048 10.5 3.82663 10.5 4.125V10.5H4.125C3.82663 10.5 3.54048 10.6185 3.3295 10.8295C3.11853 11.0405 3 11.3266 3 11.625C3 11.9234 3.11853 12.2095 3.3295 12.4205C3.54048 12.6315 3.82663 12.75 4.125 12.75H10.5V19.125C10.5 19.4234 10.6185 19.7095 10.8295 19.9205C11.0405 20.1315 11.3266 20.25 11.625 20.25C11.9234 20.25 12.2095 20.1315 12.4205 19.9205C12.6315 19.7095 12.75 19.4234 12.75 19.125V12.75H19.125C19.4234 12.75 19.7095 12.6315 19.9205 12.4205C20.1315 12.2095 20.25 11.9234 20.25 11.625C20.25 11.3266 20.1315 11.0405 19.9205 10.8295C19.7095 10.6185 19.4234 10.5 19.125 10.5H12.75V4.125Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4ab0e958d85e0d3db064f69900784cc9.svg";
export { ForwardRef as ReactComponent };